module.exports = __webpack_public_path__ + "static/media/luma-color.fdc4fb73.svg";